import React, {useState} from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {useGetProvidersQuery} from '../../redux/services/providerApi';
import AddressField from '../common/AddressField';
import CustomNumberField from '../common/CustomNumberField';
import {formatProviderName} from '../../helpers/providers';

const TestGeolocation = props => {
  const [location, setLocation] = useState();
  const [distance, setDistance] = useState(10);
  const query = useGetProvidersQuery(
    {
      lat: location?.lat,
      lon: location?.lon,
      radius: distance,
    }, 
    {skip: !location || !location.lat || !location.lon});
  const providers = query?.data || [];
  return (
    <Stack spacing={2}>
      <AddressField
        onChange={setLocation}
        useGeocoding={true}
        showGeocoding={true}
      />
      <div>
        {location ? `Selected location: ${location.name}` : 'No location selected'}
      </div>
      <CustomNumberField
        label="Distance (miles)"
        defaultValue={distance}
        onChange={e => setDistance(e.target.value)}
      />
      <Typography variant='h1'>Matching Providers ({providers.length})</Typography>
      {
        providers.map(p =>
          <Typography key={p.id} variant='h3'>{formatProviderName(p)}</Typography>
        )
      }
    </Stack>
  );
};

export default TestGeolocation;
